/**
 * Internal dependencies
 */
import { makeLayout, render } from 'lib/controller';
import { index, sidebar } from './controller';

export default (router) => {
    router(`/`, sidebar, index, makeLayout, render);
};
